export enum EvalModel {
  GPT_4O_MINI = 'gpt-4o-mini',
  GPT_4O = 'gpt-4o',
  GPT_5_4 = 'gpt-5.4',
  GPT_5_MINI = 'gpt-5-mini',
  CLAUDE_SONNET_40 = 'claude-sonnet-4.0',
  CLAUDE_SONNET_45 = 'claude-sonnet-4.5',
  CLAUDE_OPUS_46 = 'claude-opus-4.6',
  CLAUDE_SONNET_46 = 'claude-sonnet-4.6',
}

export interface EvalPassFailConfig {
  pass_criteria: string;
  fail_criteria: string;
  na_criteria: string;
  additional_instructions?: string | null;
}

export interface EvalScoreConfig {
  min_score: string;
  max_score: string;
  score_criteria: { [score: string]: string };
  additional_instructions?: string | null;
}

export interface CreateEvalRequest {
  name: string;
  type: string;
  description: string;
  model?: EvalModel;
  eval_config?: EvalScoreConfig | EvalPassFailConfig;
}

export interface Eval {
  id: string;
  name: string;
  type: string;
  description: string;
  model?: EvalModel;
  eval_config?: EvalScoreConfig | EvalPassFailConfig;
  orgid?: string;
  created_at?: string;
  updated_at?: string;
  is_new?: boolean;
  is_v2?: boolean;
}

export interface TestEvaluation {
  evalId: string;
  name: string;
  score?: number | 'pass' | 'fail' | 'n/a';
}

export interface ContentTestConfig {
  contents?: string[];
}

export interface CreateTestRequest {
  id: string;
  name: string;
  evaluations: string[];
  test_type: 'content_test';
  test_config: ContentTestConfig;
}

export interface Test extends CreateTestRequest {
  id: string;
  created_at: Date;
  updated_at?: Date;
  orgid?: string;
  is_new?: boolean;
}

export interface TestResult {
  id: string; // NOTE: this is actually the run id
  run_id?: string;
  testid?: string;
  name: string;
  created_at: string;
  eval_results: EvalResult[];
  id_to_content?: Record<string, string>;
  orgid?: string;
  run_date?: string;
  updated_at?: string;
}

export interface EvalResult {
  message: string;
  eval_id: string;
  eval_name?: string;
  input_results: SourceEvalResult[];
  aggregate_result?: Record<string, number>;
}

export interface SourceEvalResult {
  response: Response;
  source_id: string;
  id: string;
}

export interface Response {
  explanation: string | string[];
  verdict?: string;
  score?: number;
}

export interface AutoGenerateEvalConfigRequest {
  model: string;
  eval_desc: string;
  na_allowed?: boolean;
}

export interface AutoGenerateEvalConfigResponse {
  pass_criteria: string;
  fail_criteria: string;
  na_criteria: string;
}

export interface AutoGenerateScoreEvalConfigRequest {
  model: string;
  eval_desc: string;
  min_score: number;
  max_score: number;
}

export interface AutoGenerateScoreEvalConfigResponse {
  scoring_criteria: { [score: string]: string };
}
